import { Box, FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material';

interface TimeInputProps {
    label?: string;
    value?: string;
    onChange?: (newValue: SelectChangeEvent) => void;
    placeholder?: string;
    disabled?: boolean;
    error?: boolean;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    [key: string]: unknown;
}

const generateTimeOptions = (stepMinutes = 15) => {
    const times: string[] = [];
    for (let hour = 0; hour < 24; hour++) {
        for (let min = 0; min < 60; min += stepMinutes) {
            const formatted = `${String(hour).padStart(2, '0')}:${String(min).padStart(2, '0')}`;
            times.push(formatted);
        }
    }
    return times;
};

const TimeInput = ({
    // label = 'Time',
    value = '',
    onChange = () => null,
    placeholder = 'Select time',
    disabled = false,
    // error,
    onBlur = () => null,
    ...props
}: TimeInputProps) => {
    const handleChange = (event: SelectChangeEvent) => {
        onChange(event);
    };

    const timeOptions = generateTimeOptions(15);

    return <Box>
        <FormControl fullWidth>
            <Select
                value={value}
                onChange={handleChange}
                onBlur={onBlur}
                disabled={disabled}
                displayEmpty
                renderValue={(selected) => selected || placeholder}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 300,
                      overflowY: 'auto'
                    }
                  }
                }}
                {...props}
            >
                {timeOptions.map((time) => (
                    <MenuItem key={time} value={time}>
                        {time}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    </Box>;
};

export default TimeInput;